
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ee-enterprise-service-management",
      function () {
        return require("private-next-pages/solutions/ee-enterprise-service-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ee-enterprise-service-management"])
      });
    }
  